export { ImageIcon } from "./ImageIcon"
export type { ImageIconProps } from "./ImageIcon"
